import { LeadersModal } from './LeadersModal';
import { useInfiniteLeaderboardQuery } from '@features/shared/api/user';
import { getLeaderboardId } from '@features/landing/grandprix/utils/leaderboard';
import { useLeaderboard } from '@features/landing/grandprix/providers/LeaderboardProvider';
import { LeadersModalList } from '@features/landing/grandprix/ui/components/LeadersModalList';
import { Tabs } from '@ui/components/Tabs';
import { useState } from 'react';
import { LeadersModalSearch } from '@features/landing/grandprix/ui/components/LeadersModal/LeadersModalSearch';
import { LandingButton } from '@features/landing/shared/ui/components/LandingButton';
import { Loader } from '@ui/components/Loader';

type Props = {
  onClose: () => void;
};

export function LeadersModalWidget({ onClose }: Props) {
  const [query, setQuery] = useState('');
  const leaderboard = useLeaderboard();

  const { data, hasNextPage, fetchNextPage, isLoading, isFetchingNextPage } =
    useInfiniteLeaderboardQuery(
      getLeaderboardId({
        clock: leaderboard.clock,
        tillAge: leaderboard.tillAge,
        leaderboardType: leaderboard.leaderboardType,
      }),
      { limit: 50, query },
    );

  return (
    <LeadersModal
      tabs={
        <>
          <Tabs
            flat
            noTabMinWidth
            tabs={leaderboard.tillAgeTabs}
            value={leaderboard.tillAge}
            onChange={leaderboard.setTillAge}
          />
          <Tabs
            flat
            noTabMinWidth
            tabs={leaderboard.clockTabs}
            value={leaderboard.clock}
            onChange={leaderboard.setClock}
          />
          <Tabs
            flat
            noTabMinWidth
            tabs={leaderboard.leaderboardTypeTabs}
            value={leaderboard.leaderboardType}
            onChange={leaderboard.setLeaderboardType}
          />
        </>
      }
      search={
        <LeadersModalSearch
          query={query}
          onQueryChange={setQuery}
          leaderboardType={leaderboard.leaderboardType}
        />
      }
      list={
        <>
          <LeadersModalList
            leaders={data}
            isLoading={isLoading}
            leaderboardType={leaderboard.leaderboardType}
          />
        </>
      }
      listLoader={isFetchingNextPage && <Loader centered />}
      showMore={
        hasNextPage && (
          <LandingButton size="14r-32" onClick={() => fetchNextPage()}>
            Показать ещё&nbsp;›
          </LandingButton>
        )
      }
      onClose={onClose}
    />
  );
}
